import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  getDigestPreferencesEditor,
  patchDigestPreferences,
  type PatchDigestPreferencesInput,
} from '@nomiss/services';
import { digestQueryKeys } from './use-digest-feed';
import { manageDigestQueryKeys } from './use-manage-digest';
import { subscriptionQueryKeys } from './use-subscription';

export const digestPreferencesEditorQueryKeys = {
  editor: ['digest-preferences', 'editor'] as const,
};

export function useDigestPreferencesEditor(
  accessToken?: string | null,
  enabled = true,
) {
  return useQuery({
    queryKey: [...digestPreferencesEditorQueryKeys.editor, accessToken ?? ''],
    queryFn: () => getDigestPreferencesEditor(accessToken),
    enabled,
  });
}

export function usePatchDigestPreferences() {
  const queryClient = useQueryClient();

  const patchMutation = useMutation({
    mutationFn: (input: PatchDigestPreferencesInput) =>
      patchDigestPreferences(input),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: manageDigestQueryKeys.preferences,
      });
      void queryClient.invalidateQueries({
        queryKey: digestPreferencesEditorQueryKeys.editor,
      });
      void queryClient.invalidateQueries({
        queryKey: subscriptionQueryKeys.me,
      });
      void queryClient.invalidateQueries({
        queryKey: subscriptionQueryKeys.sports,
      });
      void queryClient.invalidateQueries({ queryKey: digestQueryKeys.all });
    },
  });

  return { patchMutation };
}
